<template>
    <div class="container">
        <h1 >THE BLACK MOUNTAIN</h1>
        <p class="lead">Documentary | 2018 | 55' | Color | English SUB</p>

      <carousel per-page="1" navigation-enabled="true" autoplay="true" autoplay-timeout="7000">
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/16.01.jpg?alt=media&token=49a9d8fe-b574-4d82-9122-3c08d0661a06" class="d-block w-100">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/52.jpg?alt=media&token=1e0941ff-0beb-4486-9230-8d42e45fca92" class="d-block w-100" alt="...">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/19.01.jpg?alt=media&token=811005e7-6dc4-482d-928a-dec59196eb8a" class="d-block w-100" alt="...">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/05.jpg?alt=media&token=bf10770f-4f7c-44b2-b972-df59a9171049" class="d-block w-100" alt="...">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/04.jpg?alt=media&token=8d15a75d-cbd9-4d2a-ad21-b33d8ae2761d" class="d-block w-100" alt="...">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/44.jpg?alt=media&token=2b1a745c-2110-4a71-947d-582ff08368a7" class="d-block w-100" alt="...">
        </slide>

      </carousel>



<!--      <div id="carouselControls" class="carousel slide" data-bs-ride="carousel">-->
<!--        <div class="carousel-inner">-->
<!--          <div class="carousel-item active">-->
<!--          </div>-->
<!--          <div class="carousel-item">-->
<!--            <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/52.jpg?alt=media&token=1e0941ff-0beb-4486-9230-8d42e45fca92" class="d-block w-100" alt="...">-->
<!--          </div>-->
<!--          <div class="carousel-item">-->
<!--            <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/04.jpg?alt=media&token=8d15a75d-cbd9-4d2a-ad21-b33d8ae2761d" class="d-block w-100" alt="...">-->
<!--          </div>-->
<!--        </div>-->
<!--        <a class="carousel-control-prev" href="#carouselControls" role="button" data-bs-slide="prev">-->
<!--          <span class="carousel-control-prev-icon" aria-hidden="true"></span>-->
<!--          <span class="visually-hidden">Previous</span>-->
<!--        </a>-->
<!--        <a class="carousel-control-next" href="#carouselControls" role="button" data-bs-slide="next">-->
<!--          <span class="carousel-control-next-icon" aria-hidden="true"></span>-->
<!--          <span class="visually-hidden">Next</span>-->
<!--        </a>-->
<!--      </div>-->

<!--        <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/52.jpg?alt=media&token=1e0941ff-0beb-4486-9230-8d42e45fca92" class="img-fluid" alt="Responsive image">-->
        <p class="lead mt-4 mb-4">The Black Mountain tells the stories of the people evicted from their homes and transferred to the fringes of the landfill, forced to eke a living by collecting waste. The film studies the landfill as the protagonist and takes the viewer into the heart of a hellish world.</p>
        <div class='embed-container'><iframe src='https://www.youtube.com/embed/9K0C1MhU-Vw' frameborder='0' allowfullscreen></iframe></div>

      <p class="lead mt-5 mb-4">
        <span class="font-weight-normal">DIRECTOR |</span> Anton von Heiseler <br>
        <span class="font-weight-normal">CINEMATOGRAPHER |</span> Anton von Heiseler, Narayan Tushar <br>
        <span class="font-weight-normal">EDITOR |</span> Anton von Heiseler, Tanmay Kulkarni <br>
        <span class="font-weight-normal">SOUND |</span> Christoph Obermaier <br>
        <span class="font-weight-normal">PRODUCER |</span> Paul Moody, Anton von Heiseler <br>
      </p>
    </div>
</template>

<script>
    export default {
        name: "blackmountain"
    }
</script>

<style scoped>

</style>
